import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAllStudents } from "../../services/StudentService";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";
import HSTSCustomStyle from "../../utils/hstsCustomStyle";
import DataTable from "react-data-table-component";

const ManageStudentC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const navigator = useNavigate();
  const [students, setStudent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(5);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const fetchAllStudents = () => {
    setLoading(true);
    getAllStudents()
      .then((response) => {
        // setStudent(response.data);
        const data = response.data ? response.data : response;
      setStudent(Array.isArray(data) ? data : []);
      setLoading(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching students:", error);
        setError("Failed to fetch students data");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAllStudents();
  }, []);

  const viewMore = (id) => navigator(`/coordinator/studentDetails/${id}`);

  const filteredStudents = students.filter((student) => {
    const searchTerm = searchText.toLowerCase();
    return (
      student.fullName.toLowerCase().includes(searchTerm) ||
      student.phoneNumber?.toLowerCase().includes(searchTerm) ||
      student.emailAddress?.toLowerCase().includes(searchTerm) ||
      student.gender?.toLowerCase().includes(searchTerm)
    );
  });

  const columns = [
    {
      name: "S/N",
      selector: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "Student name",
      selector: (row) =>
        row.fullName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
    },
    {
      name: "Phone number",
      selector: (row) => row.phoneNumber,
      width: "160px",
    },
    {
      name: "Email",
      selector: (row) => row.emailAddress,
    },
    {
      name: "Age group",
      selector: (row) => row.ageGroup,
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
      width: "120px",
    },
    {
      name: "View",
      cell: (row) => (
        <button
          className="btn btn-link text-center fs-4 text-primary zis-ponter"
          title="Manage student"
          onClick={() => viewMore(row.studentId)}
        >
          <span className="btn btn-warning rounded-3 fw-bold"> View </span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },
  ];

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
        <SideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeMenu={activeMenu}
          toggleMenu={toggleMenu}
          windowWidth={windowWidth}
        />
        <div className="main-panel">
          <TopHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            windowWidth={windowWidth}
          />

          <div className="container mt-0">
            <div className="page-inner">
              <div className="page-header bg-white zis-shadow rounded-2 mt-2 ">
                <ul className="breadcrumbs my-md-3 mb-3  ms-0">
                  <li className="nav-home">
                    <Link to="/coordinator" className="ps-3 ps-md-0">
                      <span className="fa fa-home"></span>
                    </Link>
                  </li>
                  <li className="separator">
                    <i className="fas fa-chevron-right text-secondary"></i>
                  </li>
                  <li className="nav-item text-black fw-semibold">
                    <Link to="#">Manage students</Link>
                  </li>
                </ul>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card zis-shadow">
                    <div className="card-header">
                      <div className="card-title d-flex">
                        <h3 className="mt-2">Manage students</h3>
                        <button
                          className="ms-auto d-none d-sm-inline btn btn-black rounded-5 py-0"
                          onClick={() => navigator("/coordinator/addStudent")}
                        >
                          <i className="fa fa-plus-circle me-1"></i> Add student
                        </button>
                      </div>
                    </div>

                    <div className="card-header d-sm-none">
                      <div className="d-flex">
                        <div className="d-flex align-items-center">
                          <span className="me-2">Show</span>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "80px" }}
                            value={perPage}
                            onChange={(e) => setPerPage(Number(e.target.value))}
                          >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                          </select>
                          <span className="ms-2">entries</span>
                        </div>
                        <div className="ms-auto">
                          <button
                            className="ms-auto btn btn-black rounded-5 py-2"
                            onClick={() => navigator("/coordinator/addStudent")}
                          >
                            <i className="fa fa-plus-circle me-1"></i> Add
                            student
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-header d-flex justify-content-between align-items-center pt-4 px-4">
                      <div className="d-none d-sm-flex align-items-center">
                        <span className="me-2">Show</span>
                        <select
                          className="form-select form-select-sm"
                          style={{ width: "80px" }}
                          value={perPage}
                          onChange={(e) => setPerPage(Number(e.target.value))}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                        <span className="ms-2">entries</span>
                      </div>
                      <div className="d-flex ms-auto">
                        <input
                          type="text"
                          className="form-control form-control-sm me-2 "
                          placeholder="Search..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{ width: "200px" }}
                        />
                      </div>
                    </div>

                    <div className="card-body">
                      <div className="table-responsive">
                        {error ? (
                          <div className="text-center text-danger py-3">
                            {error}
                          </div>
                        ) : (
                          <DataTable
                            key={`data-table-${perPage}`}
                            columns={columns}
                            data={filteredStudents}
                            progressPending={loading}
                            progressComponent={
                              <div className="text-center my-3">
                                Loading students...
                              </div>
                            }
                            noDataComponent={
                              <div className="text-center py-3">
                                No students available
                              </div>
                            }
                            pagination
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            customStyles={HSTSCustomStyle}
                            highlightOnHover
                            responsive
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageStudentC;
